<template>
<article>
    <p>
        To prevent a Service Level Objectives violation your team should be notified when an Error Budget is being consumed too quickly.
        Coroot's SLO-based alerting uses the predefined multi-window burn rate thresholds:
    </p>
    <BurnRateThresholds class="mb-4" />
    <p>
        An alert will be fired if the error budget burn rate is greater than the threshold in both long and short windows.
        Checking in the short window makes sure that the error budget is still being consumed.
    </p>

    <p>
        When calculating the error budget burn rate, Coroot requires that at least half of the particular window contains SLI data.
        This requirement helps prevent false positive alerts for low-traffic services.
    </p>

    <v-alert color="grey" outlined icon="mdi-book-open-variant">
        The detailed explanation of SLO-based alerting you can find in
        <a href="https://sre.google/workbook/alerting-on-slos/" target="_blank">The SRE Workbook</a>.
    </v-alert>

    <h2>Integrations</h2>
    <p>Coroot supports the following notification integrations:</p>
    <ul>
        <li><router-link :to="{params: {item: 'slack'}}">Slack</router-link></li>
        <li><router-link :to="{params: {item: 'teams'}}">Microsoft Teams</router-link></li>
        <li><router-link :to="{params: {item: 'pagerduty'}}">Pagerduty</router-link></li>
        <li><router-link :to="{params: {item: 'opsgenie'}}">Opsgenie</router-link></li>
        <li><router-link :to="{params: {item: 'webhook'}}">Webhook</router-link></li>
    </ul>
</article>
</template>

<script>
import BurnRateThresholds from "@/components/BurnRateThresholds.vue";

export default {
    components: {BurnRateThresholds},
}
</script>

<style scoped>

</style>
